import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { Card, Row, Col } from 'antd';

const DecisionComparisonChart = () => {
  // Column Chart Configuration
  const columnChartOptions = {
    chart: {
      type: 'column',
    },
    title: {
      text: 'Decision Comparison - Column Chart',
    },
    xAxis: {
      categories: ['User A', 'User B', 'User C', 'User D'],
      title: {
        text: 'Users',
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Decision Score',
        align: 'high',
      },
      labels: {
        overflow: 'justify',
      },
    },
    tooltip: {
      valueSuffix: ' decisions',
    },
    series: [
      {
        name: 'Decision 1',
        data: [2, 4, 5, 3],
      },
      {
        name: 'Decision 2',
        data: [3, 5, 4, 2],
      },
      {
        name: 'Decision 3',
        data: [4, 3, 5, 6],
      },
    ],
  };

  // Pie Chart Configuration
  const pieChartOptions = {
    chart: {
      type: 'pie',
    },
    title: {
      text: 'Decision Distribution - Pie Chart',
    },
    series: [
      {
        name: 'Decisions',
        data: [
          { name: 'Decision 1', y: 3 },
          { name: 'Decision 2', y: 5 },
          { name: 'Decision 3', y: 8 },
        ],
      },
    ],
  };

  // Line Chart Configuration
  const lineChartOptions = {
    chart: {
      type: 'line',
    },
    title: {
      text: 'Decision Trend - Line Chart',
    },
    xAxis: {
      categories: ['User A', 'User B', 'User C', 'User D'],
      title: {
        text: 'Users',
      },
    },
    yAxis: {
      title: {
        text: 'Decision Score',
      },
    },
    tooltip: {
      valueSuffix: ' decisions',
    },
    series: [
      {
        name: 'Decision 1',
        data: [2, 4, 5, 3],
      },
      {
        name: 'Decision 2',
        data: [3, 5, 4, 2],
      },
      {
        name: 'Decision 3',
        data: [4, 3, 5, 6],
      },
    ],
  };

  return (
    <Row gutter={16}>
      <Col span={24}>
        <Card title="Decision Comparison - Column Chart" bordered={false}>
          <HighchartsReact highcharts={Highcharts} options={columnChartOptions} />
        </Card>
      </Col>
      <Col span={24}>
        <Card title="Decision Distribution - Pie Chart" bordered={false}>
          <HighchartsReact highcharts={Highcharts} options={pieChartOptions} />
        </Card>
      </Col>
      <Col span={24}>
        <Card title="Decision Trend - Line Chart" bordered={false}>
          <HighchartsReact highcharts={Highcharts} options={lineChartOptions} />
        </Card>
      </Col>
    </Row>
  );
};

export default DecisionComparisonChart;
